module.exports = __webpack_public_path__ + "static/media/Pradashini Subramaniam.f8fc89be.png";